<script>
//utils
import swissRoundHelper from './mixins/roundHelper';
//components
import MatchCard from '../components/DuelMatchCard.vue';
import MatchCardDetails from '../components/DuelMatchCardDetails.vue';
import Grid from '../components/GridView';
const getRoundVisibleCountBase = (roundIndex, pageSize) => pageSize;
const getRoundItemHeight = basicHeight => () => basicHeight;
const getNextMatchIndex = index => Math.floor(index);
const matchProps = () => ({
  props: {
    isTreeMode: false,
    canSwapPlayers: true,
  },
});
export default {
  name: 'TournamentSwiss',
  functional: true,
  props: {
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
  render(h, context) {
    return h(Grid, {
      props: {
        roundName: swissRoundHelper.methods.roundName,
        getRoundItemHeight,
        getRoundVisibleCountBase,
        getNextMatchIndex,
        matchProps,
        isCollapsible: false,
        matchCardComponent: MatchCard,
        isAdmin: context.props.isAdmin,
        matchCardDetailsComponent: MatchCardDetails,
      },
      on: context.listeners,
    });
  },
};
</script>
